import {Injectable} from '@angular/core';
import {Procedure} from '../models/procedure-modal';
import {ApiService} from './api.service';
import {HttpClient} from '@angular/common/http';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {BehaviorSubject, Observable} from 'rxjs';

const routes = {
  create: '/procedure/create',
  update: '/procedure/update',
  updateStatus: '/procedure/update-status',
  search: '/procedure/search',
  searchV2: '/procedure/search-permission',
  searchDetail: '/procedure/search-details',
  checkCustomerUser: '/procedure/check-customer-user',
  delete: '/procedure/delete',
}

@Injectable({
  providedIn: 'root'
})
export class ProcedureService {

  procedure: Procedure[];
  public isDuplicateProcedure: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private apiService: ApiService,
    private httpClient: HttpClient
  ) { }

  searchProcedure(filter: any){
    return this.apiService.post(routes.search, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }
  searchProcedureV2(filter: any){
    return this.apiService.post(routes.searchV2, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  searchProcedureDetails(filter: any){
    return this.apiService.post(routes.searchDetail, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }
  checkCustomerUser(filter: any){
    return this.apiService.post(routes.checkCustomerUser, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  addProcedure(data: any): Observable<any> {
    return this.apiService.post(routes.create, data)
      .pipe(map(res => {
          return res;
        }
      ));
  };

  updateProcedure(data: any) {
    return this.apiService.post(routes.update, data)
      .pipe(map(res => {
          return res;
        }
      ));
  }

  updateProcedureStatus(data: any) {
    return this.apiService.post(routes.updateStatus, data)
      .pipe(map(res => {
          return res;
        }
      ));
  }

  deleteProcedure(data: any) {
    return this.apiService.post(routes.delete, data)
      .pipe(map(res => {
          return res;
        }
      ));
  }

  resetData() {
    this.isDuplicateProcedure.next(false);
  }

}
